import { decamelizeKeys, camelizeKeys } from "humps";
import { getCookie } from "helpers/cookies";
import { X_UPSERVE_AUTH_TOKEN } from "constants/app";
import { IRequestOptions, IError } from "types/requests";

function postRequest<T, U>(
  values: T = {} as T,
  headers: U = {} as U
): IRequestOptions {
  const authToken = getCookie(X_UPSERVE_AUTH_TOKEN) || "";
  return {
    method: "POST",
    credentials: "include",
    mode: "cors",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "X-Auth-Token": authToken,
      ...headers,
    },
    // @ts-expect-error TODO please fix this error
    body: JSON.stringify(decamelizeKeys(values)),
  };
}

function putRequest<T, U>(
  values: T = {} as T,
  headers: U = {} as U
): IRequestOptions {
  const authToken = getCookie(X_UPSERVE_AUTH_TOKEN) || "";
  return {
    method: "PUT",
    credentials: "include",
    mode: "cors",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "X-Auth-Token": authToken,
      ...headers,
    },
    // @ts-expect-error TODO please fix this error
    body: JSON.stringify(decamelizeKeys(values)),
  };
}

function deleteRequest<T>(headers: T = {} as T): IRequestOptions {
  const authToken = getCookie(X_UPSERVE_AUTH_TOKEN) || "";
  return {
    method: "DELETE",
    credentials: "include",
    mode: "cors",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "X-Auth-Token": authToken,
      ...headers,
    },
  };
}

function getRequest<T>(headers: T = {} as T): IRequestOptions {
  const authToken = getCookie(X_UPSERVE_AUTH_TOKEN) || "";
  return {
    method: "GET",
    credentials: "include",
    mode: "cors",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "X-Auth-Token": authToken,
      ...headers,
    },
  };
}

// Parses the response so that FE can gracefully handle the following scenarios:
// Success with response body
// Error with response body
// Error with NO response body
function parseStatusAndBody<T>(response: Response): Promise<[number, T]> {
  return Promise.all([response.status, response.json()]).catch(() => {
    // response.json() has thrown an error, likely because there is no response body
    throw [response.status, {}] as [number, IError];
  });
}

function checkStatus<T>([status, body]: [number, T]): Promise<T> {
  // @ts-expect-error TODO please fix this error
  const formattedBody = camelizeKeys(body);

  if (status >= 200 && status < 300) {
    // @ts-expect-error TODO please fix this error
    return formattedBody as Promise<T>;
  }

  throw [status, formattedBody];
}

function checkStatusRaw<T>([status, body]: [number, T]): Promise<T> {
  const converted = body as unknown;

  if (status >= 200 && status < 300) {
    return converted as Promise<T>;
  }

  throw [status, converted];
}

export {
  postRequest,
  putRequest,
  deleteRequest,
  getRequest,
  checkStatus,
  checkStatusRaw,
  parseStatusAndBody,
};
